
export enum InvoicePreferenceCd {
	ALL = 'All',
	TRANS_MODE = 'TransMode'}

